export function normalizePathname(pathname: string): string {
	if (pathname === '/') return pathname;

	const pathnameWithoutTrailingSlash = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
	return pathnameWithoutTrailingSlash || '/';
}

export function routePathMatches(pathname: string, routePath: string): boolean {
	const pathnameSegments = normalizePathname(pathname).split('/');
	const routeSegments = normalizePathname(routePath).split('/');

	if (pathnameSegments.length !== routeSegments.length) return false;

	return routeSegments.every((routeSegment, index) => routeSegment.startsWith(':') || routeSegment === pathnameSegments[index]);
}

export function pathnameMatchesSomeRoute(pathname: string, routePaths: readonly string[]): boolean {
	return routePaths.some((routePath) => routePathMatches(pathname, routePath));
}
